<template>
    <div style="width: 100%; height: 100%; display: flex; justify-content: center;"  v-loading="ischat">
      <div style="width: 85%;margin-top: 1%; height: 100%">
      <v-md-editor
        v-model="text"
        left-toolbar="undo redo | customToolbar1 customToolbar2 customToolbar3"
        :toolbar="toolbar"
        height="80%"
        :preview="true"
      />
      <div style="text-align: right; margin-top: 10px;margin-bottom: 10px;">
        <el-button @click="addCopywriting" :loading="ischat" type="primary"
          >保存</el-button
        >
        <el-button @click="AIGeneration" :loading="ischat" type="primary"
          >重新生成</el-button
        >
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  //import MarkdownIt from 'markdown-it';
  export default {
    props: {
      AICardtransfer: Object,
      markdown: {
        type: String,
        required: true,
      },
    },
    setup(props, { emit }) {
      props = JSON.parse(JSON.stringify(props));
      emit("123", props);
    },
    data() {
      this.toolbar = {};
      return {
        text: "",
        AItransfers: {},
        Answer: "",
        ischat: false,
        SModelEventPlanningList: []
      };
    },
  
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    watch: {
      AICardtransfer:{
        handler(newName) {
          this.AItransfers = JSON.parse(JSON.stringify(this.$props)).AICardtransfer;
          if(this.AItransfers.answer != undefined) {
            if (this.AItransfers.answer === "" ||this.AItransfers.answer === undefined) {
              console.log(newName)
              this.AIGeneration();
            } else {
              this.text = this.AItransfers.answer
            }
            this.GetSModelEventPlanning()
          }
        }
      }
    },
    created() {
      this.AItransfers = JSON.parse(JSON.stringify(this.$props)).AICardtransfer;
      if(this.AItransfers.answer != undefined) {
        if (this.AItransfers.answer === "" ||this.AItransfers.answer === undefined) {
          this.AIGeneration();
        } else {
          this.text = this.AItransfers.answer
        }
        this.GetSModelEventPlanning()
      }
    },
    methods: {
      AIGeneration() {
        this.ischat = true; 
        try {
          // 创建 XMLHttpRequest 对象
          const xhr = new XMLHttpRequest();
          // 设置请求的 URL
          xhr.open("POST", this.Global.chaturl + `api/Chat/ChatRequstStream`, true);
          // 设置响应类型为 text/event-stream
          xhr.setRequestHeader("Content-Type", "application/json");
          // 监听 readyStateChange 事件
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 3) {
              // 如果 readyState 是 3，表示正在接收数据
             //  this.text = xhr.responseText.replace('\n','');
            }
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                this.ischat = false;
                if (xhr.responseText == "") { 
                  this.$message.warning("AI生成失败，请联系管理员！");
                  return;
                }
                // 避免接受过程中缺少字符
                this.text =  xhr.responseText
              }
            }
          };
          xhr.send(
            JSON.stringify({
              msg: this.AICardtransfer.problem,
              username: this.Global.UserName,
              UUID: this.Global.UUID,
            })
          );
        } catch (error) {
          this.ischat = false;
          this.loading = false;
          console.log(error);
        }
      },
      GetSModelEventPlanning () {
        this.$http
          .get(
            "SModel/GetTypeSModel?round=" +
            this.Round +
            "&typename=S_Activity"
          )
          .then((res) => {
            if (res.success) {
              this.SModelEventPlanningList = res.dynamicObj;
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      addCopywriting(){
        this.ischat = true;
        if(this.AItransfers.type == this.Global.AiEnum.活动文案){
          let uuid = this.uuid.guid();
          let state = this.Global.SModel.Create;
          let list = this.SModelEventPlanningList.filter(c => c.state != this.Global.SModel.Delete);
          let that = this;
          if (list.length > 0 ) {
            list[0].copywriting = this.text
            list[0].state = this.Global.SModel.Update
            list[0].sTTime = that.filter.formatDate(new Date())
          }else{
            list.push({
              copywriting : this.text,
              uuid : uuid,
              state : state,
              round : that.Round,
              type : "S_Activity",
              sTTime : that.filter.formatDate(new Date())
            })
          }

              that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  if (state == this.Global.SModel.Update) {
                    // that.Global.sendmsgmd(
                    //   "会展服务",
                    //   `编辑了活动`,
                    //   1
                    // );
                  } else {
                    // that.Global.sendmsgmd(
                    //   "会展服务",
                    //   `举办了活动`,
                    //   1
                    // );
                    that.$store.commit("chatShow",{ isOperate : !that.ChatShow, chatValue: that.Global.OperateType.活动策划 });  
                    this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'活动策划');
                  }
                  this.determine()
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });
        }else{
          this.determine()
        }
      },
      determine() {
        let ai = {
          id: this.AICardtransfer.id,
          Answer: this.text,
          GroupId: 0,
          Round: this.Round,
          Type: this.AICardtransfer.type,
          ParentID: this.AICardtransfer.parentID
        };
        this.$http.post("StudentData/AddOrUpdateAI", ai).then((res) => {
          if (res.success) {
            if(this.AICardtransfer.type == this.Global.AiEnum.会展策划){
              this.$http
              .get("StudentData/GetSetpPlan?round="+this.Round).then((ress) => {
                if (ress.success) {
                  this.ischat = false;
                  return this.$message.success("保存成功！");
                } else {
                  return this.$message.error(res.message);
                }
              });
            }else{
              this.ischat = false;
            return this.$message.success("保存成功！");
            }
          } else {
            return this.$message.warning(res.dynamicObj);
          }
        });
      },
      convertToMarkdown(data) {
        // 将字符串中的 '\\n' 替换为实际的换行符 '\n'
        data = data.replace(/\\n/g, "\n");
        // 将数据分割为每行
        const rows = data.split("\n");
        // 构建Markdown表格
        let markdownTable = "";
        for (let row of rows) {
          // 处理每行数据
          if (row.trim() !== "") {
            markdownTable += row.trim() + " ";
          } else {
            markdownTable += "|\n";
          }
        }
  
        return markdownTable;
      },
    },
  };
  </script>
  
  <style>
  </style>